module.exports = __webpack_public_path__ + "img/1212a_1.a5200d33.jpg";